export const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('/app/front/src/pages/index.vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('/app/front/src/pages/account.vue'),
    /* no children */
  },
  {
    path: '/companies',
    name: 'Entreprises',
    component: () => import('/app/front/src/pages/companies.vue'),
    /* no children */
    meta: {
      "title": "Recherchez parmis toutes les entreprises"
    },
  },
  {
    path: '/company/:id',
    name: 'Company',
    component: () => import('/app/front/src/pages/company.[id].vue'),
    /* no children */
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('/app/front/src/pages/dashboard.vue'),
    /* no children */
  },
  {
    path: '/evaluation-externe',
    name: 'EvaluationExterne',
    component: () => import('/app/front/src/pages/evaluation-externe.vue'),
    /* no children */
    meta: {
      "title": "Évaluer une prestation",
      "requiresAuth": false
    },
  },
  {
    path: '/evaluation/:id',
    name: 'Evaluation',
    component: () => import('/app/front/src/pages/evaluation.[id].vue'),
    /* no children */
    meta: {
      "title": "Évaluation de mission",
      "requiresAuth": true
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('/app/front/src/pages/forgot-password.vue'),
    /* no children */
    meta: {
      "title": "Mot de passe oublié",
      "requiresOffline": true
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('/app/front/src/pages/login.vue'),
    /* no children */
    meta: {
      "title": "Connexion",
      "requiresOffline": true
    },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('/app/front/src/pages/maintenance.vue'),
    /* no children */
    meta: {
      "requiresAuth": false,
      "title": "Maintenance"
    },
  },
  {
    path: '/manage',
    /* internal name: '/manage' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Manage',
        component: () => import('/app/front/src/pages/manage/index.vue'),
        /* no children */
        meta: {
          "title": "Admininistration",
          "requiresAdmin": true
        },
      },
      {
        path: 'external-reviews',
        name: 'ManageExternalReviews',
        component: () => import('/app/front/src/pages/manage/external-reviews.vue'),
        /* no children */
        meta: {
          "title": "Évaluations externes",
          "requiresAdmin": true
        },
      },
      {
        path: 'parameters',
        name: 'ManageParameters',
        component: () => import('/app/front/src/pages/manage/parameters.vue'),
        /* no children */
        meta: {
          "title": "Paramètres - Administration",
          "requiresAdmin": true
        },
      },
      {
        path: 'tags',
        name: 'ManageTags',
        component: () => import('/app/front/src/pages/manage/tags.vue'),
        /* no children */
        meta: {
          "title": "Tags - Admininistration",
          "requiresAdmin": true
        },
      },
      {
        path: 'tests',
        name: 'ManageTests',
        component: () => import('/app/front/src/pages/manage/tests.vue'),
        /* no children */
        meta: {
          "title": "Tests",
          "requiresAdmin": true
        },
      },
      {
        path: 'users',
        name: 'ManageUsers',
        component: () => import('/app/front/src/pages/manage/users.vue'),
        /* no children */
        meta: {
          "title": "Gestion des utilisateurs",
          "requiresAdmin": true
        },
      },
      {
        path: 'users/:id',
        name: 'ManageUserDetails',
        component: () => import('/app/front/src/pages/manage/users.[id].vue'),
        /* no children */
        meta: {
          "title": "Détails utilisateur",
          "requiresAdmin": true
        },
      },
      {
        path: 'whitelist',
        name: 'ManageWhitelist',
        component: () => import('/app/front/src/pages/manage/whitelist.vue'),
        /* no children */
        meta: {
          "title": "Whitelist des pilotes",
          "requiresAdmin": true
        },
      }
    ],
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('/app/front/src/pages/messages.vue'),
    /* no children */
    meta: {
      "title": "Conversations"
    },
  },
  {
    path: '/my-tenders/:action?/:id?',
    name: 'MyTenders',
    component: () => import('/app/front/src/pages/my-tenders.[[action]].[[id]].vue'),
    /* no children */
  },
  {
    path: '/pilotes',
    name: 'Pilotes',
    component: () => import('/app/front/src/pages/pilotes.vue'),
    /* no children */
    meta: {
      "title": "Recherchez parmis tous nos pilotes"
    },
  },
  {
    path: '/profile/:id/:page?',
    name: 'Profile',
    component: () => import('/app/front/src/pages/profile.[id].[[page]].vue'),
    /* no children */
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('/app/front/src/pages/register.vue'),
    /* no children */
    meta: {
      "title": "Inscription",
      "requiresOffline": true
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('/app/front/src/pages/reset-password.vue'),
    /* no children */
    meta: {
      "title": "Réinitialiser le mot de passe",
      "requiresOffline": true
    },
  },
  {
    path: '/tenders',
    name: 'Tenders',
    component: () => import('/app/front/src/pages/tenders.vue'),
    /* no children */
    meta: {
      "title": "Recherchez parmis les appels d'offres publiés"
    },
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

